import React, { useState, useRef } from "react";
import { useMediaQuery, Alert } from "@mui/material";
import TransitionContainer from "../Common/TransitionContainer";
import { PurpleTextArea } from "../Style";
import { PurpleBtn, PurpleCopyPasteBtn } from "../../Common/Style";
import { useNavigate } from "react-router-dom";
import { Snackbar } from "@mui/joy";

import SaveExitBtn from "../SaveExitBtn";
import { useWritingQuestion } from "../hooks/useWritingQuestion";
import { useWritingSubmission } from "../hooks/useWritingSubmission";
import { useWritingClipboard } from "../hooks/useWritingClipboard";
import { formatWritingText, countWords } from "../utils/writingHelpers";
import { WRITING_GUIDELINES } from "../constants/writingConstants";

export default function WritingSectional({
  ExamId,
  quest,
  setStep,
  step,
  totalQuestions,
  MockTestAttemptID,
  questionsTime,
  startStopwatch,
  stopStopwatch,
  resetQuestionTimer,
  endTestAndTimeout,
  submitTriggerRef, 
}) {
  const [value, setValue] = useState("");
  const textAreaRef = useRef(null);
  const navigate = useNavigate();
  const isLaptopTwo = useMediaQuery("(max-width:1000px)");

  const { questData, loading, disabled, setDisabled } = useWritingQuestion(quest, startStopwatch);

  const { networkError, setNetworkError, handleNext } = useWritingSubmission({
    quest,
    questData,
    value,
    questionsTime,
    MockTestAttemptID,
    ExamId,
    step,
    totalQuestions,
    setStep,
    setValue,
    setDisabled,
    stopStopwatch,
    resetQuestionTimer,
    endTestAndTimeout,
    submitTriggerRef
  });

  const { alertMessage, showAlert, setShowAlert, handleCopy, handleCut, handlePaste } = useWritingClipboard(
    textAreaRef,
    value,
    setValue
  );

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const isSummarizeWrittenText = quest?.SubCategory === "Summarize Written Text";
  const preventCopyUnlessSummarizeWrittenText = (event) => {
    if (!isSummarizeWrittenText) {
      event.preventDefault();
    }
  };

  return (
    <div style={{}}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={4000}
        open={networkError}
        variant={"outlined"}
        color={"danger"}
        onClose={() => {
          setNetworkError(false);
        }}
      >
        Network Error
      </Snackbar>
      <Snackbar
        open={showAlert}
        autoHideDuration={3000}
        onClose={() => setShowAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 0,
            margin: 0,
          },
        }}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: isLaptopTwo ? "1rem 5% 2rem" : "3rem 5% 2rem",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            // height: "400px",
            width: "100%",
            borderRadius: "24px",
            position: "relative",
            overflow: "clip",
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "#e2e2ea",
              height: "13px",
              position: "absolute",
            }}
          ></div>
          <div
            style={{
              width: `${(step / totalQuestions) * 100}%`,
              backgroundColor: "#996cfe",
              height: "13px",
              position: "absolute",
            }}
          ></div>
          <TransitionContainer isInitialLoading={loading && !questData} isFetchingNext={loading && !!questData}>
            <div style={{ height: "100%" }}>
              <h1
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  lineHeight: "32px",
                  userSelect: "none",
                }}
                onCopy={(e) => e.preventDefault()}
              >
                {WRITING_GUIDELINES[quest?.SubCategory]}
              </h1>
              <h5
                style={{
                  fontSize: "18px",
                  fontWeight: 400,
                  lineHeight: "28px",
                  userSelect: isSummarizeWrittenText ? "text" : "none",
                }}
                onCopy={preventCopyUnlessSummarizeWrittenText}
              >
                {" "}
                {formatWritingText(quest?.QuestionStatement)}
              </h5>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "0.4rem",
                  gap: "0.2rem",
                }}
              >
                <PurpleCopyPasteBtn onClick={handleCopy}>
                  Copy
                </PurpleCopyPasteBtn>
                <PurpleCopyPasteBtn onClick={handleCut}>Cut</PurpleCopyPasteBtn>
                <PurpleCopyPasteBtn onClick={handlePaste}>
                  Paste
                </PurpleCopyPasteBtn>
              </div>

              <div spellCheck={false} style={{ position: "relative" }}>
                <PurpleTextArea
                  ref={textAreaRef}
                  placeholder="Write here..."
                  value={value}
                  rows={16}
                  onChange={handleChange}
                />
                <p style={{ position: "absolute", bottom: 0, right: 15 }}>
                  {countWords(value)} Words
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "25px",
                }}
              >
                <SaveExitBtn />

                {disabled ? (
                  <PurpleBtn disabled={true}>Loading...</PurpleBtn>
                ) : (
                  <PurpleBtn
                    onClick={handleNext}
                    disabled={value.trim() === "" ? true : false}
                  >
                    Next
                  </PurpleBtn>
                )}
              </div>
            </div>
          </TransitionContainer>
        </div>
      </div>
    </div>
  );
}
